import { useEffect, useState, useEffectEvent } from 'react';

import canopy from './flyingCanopy.png';
import windT from './WindT.png';
import sydKarta from './sydkartaSquare-small.jpg';
import hlT from './HL_T.png'
import land from './landingPoint.png'

import barigo from '../assets/altimiter/barigo.png'
import barigoArm from '../assets/altimiter/barigoArm.png'

import Button from 'react-bootstrap/Button';

import windCone0 from './windCone/windCone0.png'
import windCone20 from './windCone/windCone20.png'
import windCone40 from './windCone/windCone40.png'
import windCone60 from './windCone/windCone60.png'
import windCone80 from './windCone/windCone80.png'
import windCone100 from './windCone/windCone100.png'
import { Col, Form, Row } from 'react-bootstrap';

function useInterval(callback, delay) {
    const onTick = useEffectEvent(callback);

    useEffect(() => {
        if (delay === null) {
            return;
        }
        const id = setInterval(() => {
            onTick();
        }, delay);
        return () => clearInterval(id);
    }, [delay, onTick]);
}

const randomWind = () => ({
    direction: Math.random() * 2 * Math.PI,
    speed: Math.random() * 10
});

const CanopyPage = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setScreenHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [canvas, setCanvas] = useState();

    const [exitAlt, setExitAlt] = useState(600);

    const stepTime = 16.6; //ms
    const timeFactor = stepTime / 1000;
    const airSpeed = 10;
    const sinkRate = 5;

    const imageWidth = 3500; // meters also height

    const [running, setRunning] = useState(false);

    let [pos, setPos] = useState(
        { x: 300, y: 400, height: exitAlt, direction: Math.PI, landx: 0, landy: 0 }
    );
    let [wind, setWind] = useState(randomWind());

    let [arrows, setArrows] = useState({
        ArrowLeft: false,
        ArrowRight: false,
        ArrowUp: false,
        ArrowDown: false,
        Space: false,
    });
    var pixelScale = screenWidth / imageWidth;
    if (screenHeight > screenWidth) {
        pixelScale = screenHeight / imageWidth;
    }

    useInterval(() => {
        var sinkrateMultiplier = 1;
        var speedMultiplier = 1;
        var newDirection = pos.direction;
        if (arrows.ArrowRight && arrows.ArrowLeft) {
            sinkrateMultiplier = 0.6;
            speedMultiplier = 0.6;
        } else {
            if (arrows.ArrowRight) {
                speedMultiplier = 1.2;
                sinkrateMultiplier = 1.6;
                newDirection = pos.direction + (Math.PI / 3) * timeFactor;
            }
            if (arrows.ArrowLeft) {
                speedMultiplier = 1.2;
                sinkrateMultiplier = 1.6;
                newDirection = pos.direction - (Math.PI / 3) * timeFactor;
            }
        }

        var oldPos = pos;
        var newHeight = oldPos.height - (sinkRate * timeFactor * sinkrateMultiplier);
        if (newHeight < 0) {
            newHeight = 0;
        }


        var canopyVector = {
            x: (airSpeed) * Math.sin(newDirection) * speedMultiplier,
            y: ((airSpeed) * Math.cos(newDirection + Math.PI) * speedMultiplier)
        };

        var windVector = {
            x: -(wind.speed) * Math.sin(wind.direction),
            y: (wind.speed) * Math.cos(wind.direction),
        };

        var totalVector = {
            x: canopyVector.x + windVector.x,
            y: canopyVector.y + windVector.y,
        }

        var timeToGround = newHeight / (sinkRate * sinkrateMultiplier);

        var newPos = {
            x: oldPos.x + (totalVector.x * pixelScale * timeFactor),
            y: oldPos.y + (totalVector.y * pixelScale * timeFactor),
            height: newHeight,
            direction: newDirection,
            landx: oldPos.x + totalVector.x * timeToGround * pixelScale,
            landy: oldPos.y + totalVector.y * timeToGround * pixelScale,
        };

        if (canvas == null) return;
        const ctx = canvas.getContext("2d");
        ctx.lineWidth = 3;
        ctx.lineJoin = "round";
        if (pos.height < 100) {
            ctx.strokeStyle = "#ff0000";
        } else if (pos.height < 200) {
            ctx.strokeStyle = "#002aff";
        } else if (pos.height < 300) {
            ctx.strokeStyle = "#00ff00";
        } else if (pos.height < 500) {
            ctx.strokeStyle = "#FBEC5D";
        } else {
            ctx.strokeStyle = "#E0E0E0"
        }

        ctx.beginPath();
        ctx.moveTo(pos.x + 10, pos.y + 10);
        ctx.lineTo(newPos.x + 10, newPos.y + 10);
        ctx.stroke();

        setPos(newPos);
    }, running && pos.height > 0 ? stepTime : null);

    useEffect(() => {
        const handleKey = (e) => {
            const key = e.key;
            if (" " === key && e.type === "keydown") {
                console.log("running for space is: ", running);
                setRunning(state => !state);
            }
            setArrows((state) => {
                if ("ArrowLeft" === key) {
                    arrows.ArrowLeft = e.type === "keydown";
                }
                if ("ArrowRight" === key) {
                    arrows.ArrowRight = e.type === "keydown";
                }
                if ("ArrowUp" === key) {
                    arrows.ArrowUp = e.type === "keydown";
                }
                if ("ArrowDown" === key) {
                    arrows.ArrowDown = e.type === "keydown";
                }
                return arrows;
            });
        };
        document.addEventListener('keydown', handleKey, true);
        document.addEventListener('keyup', handleKey, true);

        return () => {
            document.removeEventListener('keydown', handleKey);
            document.removeEventListener('keyup', handleKey);
        };
    }, [arrows, running]);

    var windCone = windCone0;
    if (wind.speed >= 7.8) {
        windCone = windCone100;
    } else if (wind.speed >= 6) {
        windCone = windCone80;
    } else if (wind.speed >= 4.5) {
        windCone = windCone60;
    } else if (wind.speed >= 4.5) {
        windCone = windCone40;
    } else if (wind.speed >= 3) {
        windCone = windCone20;
    }

    var windDegree = ((wind.direction / (2 * Math.PI)) * 360);
    var hlTDirection = ((windDegree < 220 && windDegree > 40 ? 130 : 310));

    const endScreen = <div
        style={{
            position: 'fixed',
            inset: '0px',
            width: '30rem',
            height: '5rem',
            maxWidth: '100vw',
            maxHeight: '100vh',
            margin: 'auto',
            zIndex: 10,
        }}
    >
        <div
            style={{
                margin: '2rem',
                padding: '2rem',
                backgroundColor: '#FFFFFFBB',
                borderRadius: '2rem',
                textAlign: 'center'
            }}
        >
            <h3>Tillbaka på marken!</h3>

            <img
                key="windCone"
                style={{
                    width: 30,
                }}
                src={windCone} alt="Wind cone showing wind strength" />
            <span>&nbsp; Du hade {Math.abs(wind.speed.toFixed(1))} m/s vind</span>
            <br />
            <br />
            <img
                key="windT"
                style={{
                    width: 30,
                    transform: 'rotate(' + (windDegree) + 'deg)'
                }}
                src={windT} alt="Wind t showing wind direction" />
            <span>&nbsp;&nbsp; Från {windDegree.toFixed(0)} grader</span>
            <br />
            <br />
            <Row>
                <Form.Label htmlFor="exitAlt">Uthoppshöjd</Form.Label>
                <Col>
                    <Form.Control
                        type="number"
                        id="exitAlt"
                        defaultValue={exitAlt}
                        onChange={e => setExitAlt(Number(e.target.value))}
                        step="50"
                    />
                </Col>
                <Col md="auto">
                    <span style={{
                        fontSize: '1.5rem'
                    }}> m</span>
                </Col>
            </Row>

            <br />
            <Button
                variant="primary"
                className='waves-effect waves-light btn-lg '
                style={{ width: '50%' }} onClick={e => {
                    setRunning(false);
                    setPos({
                        x: 500,
                        y: 500,
                        height: exitAlt,
                        direction: Math.random() * 2 * Math.PI,
                        landx: 0,
                        landy: 0
                    });
                    setWind(randomWind());
                    const ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                }}>Kör igen!</Button>
        </div>
    </div>;

    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            position: 'relative',
            overflow: 'hidden',
        }}
            onClick={e => {
                if (running) {
                    return;
                }
                setPos({
                    x: e.pageX - 10,
                    y: e.pageY - 10,
                    direction: Math.random() * 2 * Math.PI,
                    height: exitAlt
                });
                setRunning(true);
            }}>

            {pos && pos.height === 0 ?
                (endScreen) : null
            }


            <img className="figure-img img-fluid rounded"
                src={barigo} alt={""}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: 200,
                    width: 200,
                    zIndex: 100
                }}
            />
            <img className="figure-img img-fluid rounded"
                src={barigoArm} alt={""}
                style={{
                    position: "absolute",
                    zIndex: 101,
                    top: 0,
                    left: 0,
                    height: 200,
                    width: 200,
                    transform: 'rotate(' + ((pos.height / 4000) * 360) + 'deg)',

                }}
            />

            <div style={{
                position: 'absolute',
                backgroundColor: 'white',
                width: '90px',
                right: '0px',
                textAlign: 'right',
                paddingRight: '5px',
                borderBottomRightRadius: '5px',
                borderBottomLeftRadius: '5px'
            }}>
                <p style={{ marginBottom: '0px', fontSize: '1.4rem' }}>
                    {Math.abs(pos.height.toFixed(0))} <span style={{ float: 'right' }}>&nbsp;m</span>
                </p>
                <p style={{ marginBottom: '0px', display: 'none' }}>
                    {Math.abs(wind.speed.toFixed(1))} <span style={{ float: 'right' }}>&nbsp;m/s</span>
                </p>
            </div>
            {!running ?
                (
                    <div
                        style={{
                            position: 'fixed',
                            inset: '0px',
                            width: '30rem',
                            height: '5rem',
                            maxWidth: '100vw',
                            margin: 'auto',
                            marginTop: '20px',
                            zIndex: 10,
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                position: 'fixed',
                                backgroundColor: 'transparent',
                                justifyContent: 'justify-content',
                                maxWidth: 'fit-content',
                                textAlign: 'center',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                fontSize: '2rem',
                                zIndex: 111,
                            }}>
                            <p
                                style={{
                                    marginBottom: 0,
                                    backgroundColor: 'white',
                                }}>
                                Klicka på din uthoppspunkt!
                            </p>
                        </div>
                    </div>) : null
            }

            <img
                key="field"
                style={{
                    zIndex: 1,
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%',
                }}
                src={sydKarta} alt="a balloon" />

            <img
                key="canopy"
                style={{
                    position: 'absolute',
                    zIndex: 3,
                    top: pos.y,
                    left: pos.x,
                    width: 20,
                    transform: 'rotate(' + ((pos.direction / (2 * Math.PI)) * 360) + 'deg)',
                    display: pos.height && running ? 'block' : 'none',

                }}
                src={canopy} alt="a canopy" />
            <img
                key="landingPoint"
                style={{
                    position: 'absolute',
                    zIndex: 3,
                    top: pos.landy,
                    left: pos.landx,
                    width: 20,
                    transform: 'rotate(' + ((pos.direction / (2 * Math.PI)) * 360) + 'deg)',
                    display: running ? 'block' : 'none',

                }}
                src={land} alt="a canopy" />

            <img
                key="windCone"
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    top: (screenHeight / 2) - 160 * pixelScale,
                    left: (screenWidth / 2) - 210 * pixelScale,
                    width: 20,
                    transform: 'rotate(' + ((wind.direction / (2 * Math.PI)) * 360 + 90) + 'deg)'

                }}
                src={windCone} alt="Wind cone showing wind strength" />

            <img
                key="windT"
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    top: screenHeight / 2 + 60 * pixelScale,
                    left: screenWidth / 2 - 20 * pixelScale,
                    width: 20,
                    transform: 'rotate(' + (windDegree) + 'deg)'

                }}
                src={windT} alt="Wind t showing wind direction" />
            <img
                key="HlT"
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    top: screenHeight / 2 - 250 * pixelScale,
                    left: screenWidth / 2 - 10 * pixelScale,
                    width: 15,
                    //(wind.direction / (2 * Math.PI)) * 360
                    transform: 'rotate(' + hlTDirection + 'deg)'

                }}
                src={hlT} alt="HL T for ordering landing direction" />


            <canvas width={screenWidth} height={screenHeight} ref={setCanvas} style={{
                zIndex: 2,
                float: 'left',
                margin: 0,
                padding: 0,
                display: 'block',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                position: 'absolute'
            }} />


        </div >);
};

export default CanopyPage;